import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var NavigationPointer02 = function NavigationPointer02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5.0369 21.3253c-.5847.2573-.877.3859-1.0565.3294a.5.5 0 0 1-.3265-.3262c-.0567-.1793.0715-.4718.3281-1.0568l7.2814-16.6015c.2316-.528.3474-.7921.5093-.873a.5.5 0 0 1 .4466 0c.1619.0809.2777.345.5094.873L20.01 20.2717c.2566.585.3849.8775.3282 1.0568a.5.5 0 0 1-.3266.3262c-.1794.0565-.4717-.0721-1.0564-.3294l-6.637-2.9203c-.1187-.0522-.178-.0783-.2397-.0886a.5.5 0 0 0-.165 0c-.0616.0103-.121.0364-.2397.0886z"
    })
  }));
};
export default NavigationPointer02;